import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard} from '../../../../_metronic/helpers'
import {EntityByProcessBody} from './components/EntityByProcessBody'
import {EntityByProcessHeader} from './components/EntityByProcessHeader'
import {EntityByProcessProvider} from './EntityByProcessContext'

const breadcrumbs = [
  {
    title: 'Configuración',
    path: '/configuracion/envio-datos',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const EntityByProcess: React.FC = () => {
  return (
    <EntityByProcessProvider>
      <BasicBreadcrumbs breadcrumbs={breadcrumbs} fallbackTitle='Configuracion de envio de datos' />
      <KTCard>
        <EntityByProcessHeader />
        <EntityByProcessBody />
      </KTCard>
    </EntityByProcessProvider>
  )
}
